// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-card-container{max-width:500px}@media screen and (min-width: 576px){.user-card-container{min-width:500px}}.user-card-container .contact-info{border-top:1px dotted #bd2534;font-size:90%;margin-top:.25em;padding:.25em}.user-card-container .user-profile-picture{height:auto;max-width:100%;min-width:150px;min-height:150px;object-fit:cover}", ""]);
// Exports
module.exports = exports;
